/*
    That's a helper function that replaces the lodash.template function with a simple string replace.
*/

export const stringTemplate = (str: string, data: Record<string, string | number | undefined>) =>
  str.replace(/\${(.*?)}/g, (_, key) => String(data[key]) ?? '');
